import React from 'react';
import { FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa';

const Footer = () => {
  return (
    
    <div className='w-full mt-24 bg-gray-900 text-gray-300 px-2 pt-3 -mt-0'>
      <div className="grid grid-cols-2 gap-8 px-4 py-6 lg:py-8 md:grid-cols-4 border-b-2 border-gray-600">
        <div>
            <h2 className="mb-6 text-sm font-semibold text-gray-600 uppercase dark:text-white">Soluções</h2>
            <ul className="text-gray-500 dark:text-gray-400 font-medium">
                <li className="mb-4">
                    <a href="/feature1" className="hover:underline">Feature 1</a>
                </li>
                <li className="mb-4">
                    <a href="/feature2" className="hover:underline">Feature 2</a>
                </li>
                <li className="mb-4">
                    <a href="/feature3" className="hover:underline">Feature 3</a>
                </li>
            </ul>
        </div>
        
        <div>
          <h6 className='font-bold uppercase pt-2'>Ajuda</h6>
          <ul>
            <li className='py-1'><a href="/about">Sobre Nós</a></li>
            <li className='py-1'><a href="/terms">Termos de Uso</a></li>
            <li className='py-1'><a href="/contact">Fale Conosco</a></li>
          </ul>
        </div>
        
        <div className='col-span-2 py-8 md:pt-2'>
          <p className='font-bold uppercase'>Fique por dentro das novidades!</p>
          <p className='py-4'>
            Saiba das últimas atualizações em primeira mão se inscrevendo em nossa Newsletter.
          </p>
          <form className='flex flex-col sm:flex-row'>
            <input className='w-6/12 p-2 mr-4 rounded-md mb-4' type='email' placeholder='Email...' />
            <button className='p-2 mb-4 rounded-md'>Inscrever-se</button>
          </form>
        </div>
      </div>

      <div className='flex flex-col max-w-[1400px] px-2 py-4 mx-auto justify-between sm:flex-row text-center text-gray-500'>
        <p className='py-4'>© 2024 Desenvolvido por ÍMPAR ESTÚDIO 3D.<br/> Todos os direitos reservados</p>

        <div className='flex justify-between sm:w-[300px] pt-4 text-2xl'>
          <a href="https://www.instagram.com"><FaInstagram /></a>
          <a href="https://www.facebook.com"><FaFacebook /></a>
          <a href="https://twitter.com"><FaTwitter /></a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
